import { createFileRoute, redirect } from '@tanstack/react-router';

// /settings → redirect a /settings/account. Felipe accede via avatar
// dropdown que apunta a /settings (nunca a /settings/account directo);
// este redirect evita una página vacía.
export const Route = createFileRoute('/_app/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/account' });
  },
});
